import {
  OrgMemberRole,
  Permissions,
  PortalSettingsAccessConsole,
  PortalSettingsAccessPortal,
} from '@nx-frontend/shared/types';

export function getPortalClientOrgRolesFromAccess(access?: PortalSettingsAccessPortal): OrgMemberRole[] {
  const roles: OrgMemberRole[] = [];
  if (!access) {
    return roles;
  }
  if (access.anyone) {
    roles.push(...Object.values(OrgMemberRole));
    return roles;
  }
  if (access.clients) {
    roles.push(OrgMemberRole.CLIENT);
  }
  if (access.guests) {
    roles.push(OrgMemberRole.GUEST);
  }
  if (access.members) {
    roles.push(OrgMemberRole.MEMBER);
  }
  if (access.managers) {
    roles.push(OrgMemberRole.MANAGER);
  }
  if (access.owner) {
    roles.push(OrgMemberRole.OWNER);
  }
  if (access.clients) {
    roles.push(OrgMemberRole.CLIENT);
  }
  return roles;
}

export function getPortalConsoleOrgRolesFromAccess(access?: PortalSettingsAccessConsole) {
  const roles: OrgMemberRole[] = [];
  if (!access) {
    return roles;
  }
  if (access.guests) {
    roles.push(OrgMemberRole.GUEST);
  }
  if (access.members) {
    roles.push(OrgMemberRole.MEMBER);
  }
  if (access.managers) {
    roles.push(OrgMemberRole.MANAGER);
  }
  if (access.owner) {
    roles.push(OrgMemberRole.OWNER);
  }
  return roles;
}

export function getUpdatedPermissions(
  permissions: Permissions,
  userIds: number[],
  userId: number,
  hasAccess: boolean
): Permissions {
  const permissionUserIds = permissions.allowUserIds.filter((permissionUserId) => userIds.includes(permissionUserId));
  if (!hasAccess) {
    if (permissions.allowAll) {
      return {
        ...permissions,
        allowAll: false,
        allowUserIds: userIds.filter((id) => id !== userId),
      };
    } else {
      return {
        ...permissions,
        allowUserIds: permissionUserIds.filter((allowUserId) => allowUserId !== userId),
      };
    }
  } else {
    if (permissions.allowAll) {
      return {
        ...permissions,
        allowAll: false,
        allowUserIds: [...userIds, userId],
      };
    } else {
      return {
        ...permissions,
        allowUserIds: [...permissionUserIds, userId],
      };
    }
  }
}

export function userHasWorkspaceAccess(userId: number, workspaceMemberUserIds: number[]) {
  return workspaceMemberUserIds.includes(userId);
}
